<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">พื้นที่</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!areaFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::area:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddAreaForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มพื้นที่
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="areas"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <AreaForm
      :formShow="areaFormShow"
      :formAction="areaFormAction"
      :area="area"
      :areaInit="areaInit"
      @isAreaDataChange="handleAreaFormDataChange"
      @formActionCompleted="handleAreaFormActionCompleted"
      @onReset="handleAreaFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="areaFormShow && areaFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import AreaForm from '@/views/area/AreaForm.vue'

export default {
  components: {
    AreaForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['area_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        { text: 'รหัสพื้นที่', value: 'area_code', width: '100' },
        { text: 'ชื่อพื้นที่', value: 'title_th', width: '280' },
        { text: 'ชื่อพื้นที่ (อังกฤษ)', value: 'title_en', width: '240' },
        { text: 'รายละเอียด', value: 'description' },
      ],
      areaFormShow: false,
      areaFormAction: '',
      area: {},
      areaInit: {},
      isAreaDataChange: false,
      interval: null,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    areas() {
      return this.$store.state.area.areas
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'พื้นที่',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchAreas: 'area/fetchAreas',
    }),
    classRowSelected(row) {
      if (this.area.area_uuid === row.area_uuid) return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::area:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.area.area_uuid === row.area_uuid) {
        this.areaFormShow = false
        this.areaFormAction = ''
        this.area = {}
        this.areaInit = {}
      } else {
        this.areaFormShow = true
        this.areaFormAction = 'edit'
        this.area = { ...row }
        this.areaInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isAreaDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddAreaForm() {
      this.areaFormShow = true
      this.areaFormAction = 'add'
      this.area = {}
      this.areaInit = {}
    },
    handleAreaFormDataChange(value) {
      this.isAreaDataChange = value
    },
    handleAreaFormReset(formAction) {
      if (formAction === 'add') {
        this.area = {}
        this.areaInit = {}
      }
      if (formAction === 'edit') this.area = { ...this.areaInit }
    },
    handleAreaFormActionCompleted(formAction) {
      this.area = {}
      this.areaInit = {}
      this.areaFormShow = false
      this.areaFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = { company_uuid }
      const areas = this.fetchAreas(payload)

      Promise.all([areas])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.areaFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isAreaDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
